module.exports = __webpack_public_path__ + "img/top_slider_homeicon.6d70840e.jpg";